import { render, staticRenderFns } from "./LayerMessage.vue?vue&type=template&id=170fc74c&scoped=true&"
import script from "./LayerMessage.vue?vue&type=script&lang=js&"
export * from "./LayerMessage.vue?vue&type=script&lang=js&"
import style0 from "./LayerMessage.vue?vue&type=style&index=0&id=170fc74c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170fc74c",
  null
  
)

export default component.exports